import { createSelector } from 'reselect'
import getItemsCartSelect from 'modules/cart/redux/selectors/get-items'

const getItemByVariantIdCartSelector = variantId => createSelector(
  getItemsCartSelect,
  (cartItems) => {
    return cartItems.find((item) => {
      return item.variant_id === variantId
    })
  }
)

export default getItemByVariantIdCartSelector
